import { controls, grouped } from "../controls";
const matchings = {
    label: "Matchings",
    pageLabel: "Matchings", starting: true, url: "autogen",
    formActions: { edit: { allow: true } },
    pageType: "history",
    filter: [
    ]
    , form: [

        ...controls.displayText({ tab: "general", width: "col-sm-2", label: "Track The Girl Child", star: true }),
        ...controls.oc({ tab: "general", c: "TrackTheGirlChild", hidden: true, placeHolder: "Track The Girl Child Code", name: "track_the_girl_child_code", isRequired: true, fastpath: "track_the_girl_childs", displayData: { mn: "mn", fathers_name: "fathers_name", village_display: "village_display", date_of_birth: "date_of_birth", taluka_display: "taluka_display", } }),
        ...controls.showData({ tab: "general", width: "col-sm-4", displaytype: "capital", data: "track_the_girl_child_display" }),


        ...controls.displayText({ tab: "general", width: "col-sm-2", label: "Mothers Name", star: true }),
        ...controls.showData({ tab: "general", width: "col-sm-4", displaytype: "capital", data: "mn" }),

        ...controls.displayText({ tab: "general", width: "col-sm-2", label: "Fathers Name", star: true }),
        ...controls.showData({ tab: "general", width: "col-sm-4", displaytype: "capital", data: "fathers_name" }),

        ...controls.displayText({ tab: "general", width: "col-sm-2", label: "Date Of Birth", star: true }),
        ...controls.showData({ tab: "general", width: "col-sm-4", displaytype: "capital", data: "date_of_birth" }),

        ...controls.displayText({ tab: "general", width: "col-sm-2", label: "village", star: true }),
        ...controls.showData({ tab: "general", width: "col-sm-4", displaytype: "capital", data: "village_display" }),

        ...controls.displayText({ tab: "general", width: "col-sm-2", label: "Taluka", star: true }),
        ...controls.showData({ tab: "general", width: "col-sm-4", displaytype: "capital", data: "taluka_display" }),

        ...controls.displayText({ tab: "general", label: "Matching Id", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "matching_id", width: "col-sm-4", maxlength: 300, placeHolder: "SARAL ID" }),
        ...controls.displayText({ tab: "general", label: "Remark", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "remark", width: "col-sm-4", maxlength: 500, placeHolder: "SCHOOL NAME,CLASS,DIV" }),



        ...controls.checkBox({ tab: "general", label: "Has child marriage happened in family(कुटुंबात यापूर्वी कुणाचा बालविवाह झाला आहे का?)", default: false, name: "is_any_child_marrige_happend_in_family", width: "col-sm-12" }),



        ...controls.checkBox({
            tab: "general", label: "single or both parents expired(एक किंवा दोन्ही पालक मृत आहेत का?)", default: false, name: "is_mom_or_dad_died", width: "col-sm-12"
        }),

        ...controls.checkBox({
            tab: "general", label: "Any history of family violence( कौटुंबिक कलहाला बळी पडलेली आहे का?)", default: false, name: "is_any_family_violence", width: "col-sm-12"
        }),

        ...controls.checkBox({
            tab: "general", label: "Failed in previous class(मागच्या वर्गात अनुत्तीर्ण आहे का?)", default: false, name: "is_failed_in_previous_class", width: "col-sm-12"
        }),

        ...controls.checkBox({
            tab: "general", label: "Any one or both  parents are handicapped(दोन्ही पालक दिव्यांग असा असलेली आहेत का?)", default: false, name: "is_both_parent_handicapped", width: "col-sm-12"
        }),




        ...controls.checkBox({
            tab: "general", label: "Has Irregular In School(शाळेत अनियमितता आहे?)", default: false, name: "is_irregular_in_school", width: "col-sm-12"
        }),




        ...controls.checkBox({
            tab: "general", label: "Dropped out from school(अर्ध्यावर शिक्षण सोडून दिले आहे का?)", default: false, name: "is_left_from_school", width: "col-sm-12"
        }),




        ...controls.checkBox({ tab: "general", label: "Is Belongs To migrant Family(स्थलांतरित कुटुंबातील आहे?)", default: false, name: "is_immigrant_family", width: "col-sm-12" }),


        ...controls.checkBox({
            tab: "general", label: "Is having more than two sisters (दोन पेक्षा जास्त बहिणी आहेत का?)", default: false, name: "is_more_than_two_sisters", width: "col-sm-12"
        }),



        ...controls.checkBox({ tab: "general", label: "child is not alive(मुलगी जिवंत नाही?)", default: false, name: "dead", width: "col-sm-12" }),

        ...controls.text({
            tab: "general", placeHolder: "", name: "matching_type", width: "col-sm-4", maxlength: 300, placeHolder: "Matching Type", hidden: true
        }),



        ...controls.checkBox({
            tab: "general", label: "Dropout With Saral Id(सरल आयडी उपलब्ध आहे परंतु शाळेत सध्या नाही?)", default: false, name: "drop_out_with_saral_id", width: "col-sm-12"
            , parents: [{ "name": "matching_type", "match": "in", "value": [3] }],
            style: { fontWeight: 600 }

        }),

        ...controls.checkBox({
            tab: "general", label: "Dropout Without Saral Id(सरल आयडी उपलब्ध नाही परंतु शाळेत शिकत होती?)", default: false, name: "drop_out_without_saral_id", width: "col-sm-12"
            , parents: [{ "name": "matching_type", "match": "in", "value": [3] },

            ],
            style: { fontWeight: 600 }

        }),

        ...controls.checkBox({
            tab: "general", label: "Having SARAL ID and studying in school(सरल आयडी उपलब्ध आहे आणि शाळेत शिकत आहे)", default: false, name: "having_saral_id_and_studying", width: "col-sm-12"
            , parents: [{ "name": "matching_type", "match": "in", "value": [3] }],
            style: { fontWeight: 600 }

        }),

        ...controls.checkBox({
            tab: "general", label: "Verified And Not Match(हा रेकॉर्ड माझ्या शाळेचा नाही याची मी पुष्टी करतो)", default: false, name: "not_match", width: "col-sm-12",
            parents: [{ "name": "matching_id", "match": "exist", "reverse": "true" },
            ],
            style: { color: "red", fontWeight: 600 }
        }),

        ...controls.checkBox({
            tab: "general", label: "None Of Above(वरील पर्यायांपैकी एकही नाही)", default: false, name: "no_change", width: "col-sm-12",
            parents: [{ "name": "matching_type", "match": "in", "value": [1] }],
            style: { color: "Green", fontWeight: 600 }
        }),


        ...controls.displayText({ tab: "general", label: "", width: "col-sm-12" }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-12" }),

        {
            widths: "col-sm-12",
            tab: "general",
            title: "Probable Matches",
            subComponents: [
                // ...controls.displayText({ tab: "general", label: "Saral Id",star:false}),
                // ...controls.text({ tab: "general",  placeHolder: "", name: "saral_id",width:"col-sm-4",maxlength:100}),
                // ...controls.displayText({ tab: "general", label: "Full Name",star:false}),
                // ...controls.text({ tab: "general",  placeHolder: "", name: "full_name",width:"col-sm-4",maxlength:200}),
                // ...controls.displayText({ tab: "general", label: "Fathers Name",star:false}),
                // ...controls.text({ tab: "general",  placeHolder: "", name: "fathers_name",width:"col-sm-4",maxlength:100}),
                // ...controls.displayText({ tab: "general", label: "Mothers Name",star:false}),
                // ...controls.text({ tab: "general",  placeHolder: "", name: "mothers_name",width:"col-sm-4",maxlength:200}),
                // ...controls.displayText({ tab: "general", label: "Data Of Birth",star:false}),
                // ...controls.text({ tab: "general",  placeHolder: "", name: "data_of_birth",width:"col-sm-4",maxlength:100}),
                // ...controls.displayText({ tab: "general", label: "School Name",star:false}),
                // ...controls.text({ tab: "general",  placeHolder: "", name: "school_name",width:"col-sm-4",maxlength:200}),
                // ...controls.displayText({ tab: "general", label: "Saral Class",star:false}),
                // ...controls.text({ tab: "general",  placeHolder: "", name: "saral_class",width:"col-sm-4",maxlength:100}),
                // ...controls.displayText({ tab: "general", label: "Village",star:false}),
                // ...controls.text({ tab: "general",  placeHolder: "", name: "village",width:"col-sm-4",maxlength:100}),
                // ...controls.displayText({ tab: "general", label: "Taluka",star:false}),
                // ...controls.text({ tab: "general",  placeHolder: "", name: "taluka",width:"col-sm-4",maxlength:100}),

                ...controls.displayText({ tab: "probable_matches", width: "col-sm-12", label: "" }),
                ...controls.displayText({ tab: "probable_matches", width: "col-sm-4", label: "" }),
                // ...controls.button({
                //   tab: "probable_matches",
                //   label: "ADD",
                //   style: { padding: 0 },
                //   Bcolor: "success",
                //   onclick: {
                //     action: "appendToHTMLTable",
                //     tableNameField: "probable_matches",
                //     requiredField: ["saral_id", "full_name", "fathers_name", "mothers_name", "data_of_birth", "school_name", "saral_class", "village", "taluka",],
                //     required: [],
                //   }, width: "col-sm-2"
                // }),
                // ...controls.button({
                //   tab: "probable_matches",
                //   label: "CLEAR",
                //   style: { padding: 0 },
                //   Bcolor: "warning",
                //   onclick: {
                //     action: "clearForm",
                //     tableNameField: "probable_matches",
                //     requiredField: ["saral_id", "full_name", "fathers_name", "mothers_name", "data_of_birth", "school_name", "saral_class", "village", "taluka",]
                //   }, width: "col-sm-2"
                // }),
                {
                    tab: "probable_matches",
                    inputType: "table",
                    tableTitle: "",
                    //deletable: true,
                    editable: true,
                    tableHeaders: [
                        { label: "Sr", type: "autoinc" },
                        { label: "Saral ", field: "saral_id" },
                        { label: "Full Name", field: "full_name" },
                        { label: "Fathers Name", field: "fathers_name" },
                        { label: "Mothers Name", field: "mothers_name" },
                        { label: "Data Of Birth", field: "data_of_birth" },
                        { label: "School Name", field: "school_name" },
                        { label: "Saral Class", field: "saral_class" },
                        { label: "Village", field: "village" },
                        { label: "Taluka", field: "taluka" },
                    ],
                    widths: {
                        parent: "col-sm-12",
                        children: "col-sm-12"
                    },
                    name: "probable_matches"
                },
            ]
        },
    ]
    , history: {
        perPage: 10,
        reportHeader: "Matchings",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        clickable: true,
        displayColumns: [
            { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
        ]
    }
};
export default matchings;